<!--商家合作 -->
<template>
  <div>
    <img
      src="@/assets/newImage/buss-bg.05lhW6xs.png"
      style="height: 170px; flex: 1; width: 100%; margin-top: 20px"
    />

    <div class="right-item-content">
      <div style="line-height: 2; color: rgb(51, 51, 51); font-size: 16px">
        现阶段主要针对金融类、运营商、航空类、互联网等公司：<br />

        1、可替员工和客户发放福利；：<br />

        2、完善企业积分系统中的供货以及回购。：<br />

        随着我司业务种类的不断增加，锦汇卡回收网平台也将诚招符合公司价值观的商家合作，希望能与您一起共筑美好的：<br />未来。
        合作电话：18236414232（企业合作、话费卡、加油卡、游戏卡、等多项预付卡）：<br />

        合作微信：zin183399<br />
        合作邮箱：2262334912@qq.com<br />

        商户网站：https://www.jinhuixinxi.cn/<br />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: #f8f8fa;
  border-radius: 8px;
}
</style>
